import {
	PrimaryColor,
	BorderColor,
	GreySidely,
	SurfaceColor
} from '../styles/global/css/Utils';
// import { useLayoutEffect } from 'react';

export const customStyles = {
	option: (provided, state) => ({
		...provided,
		padding: 10,
		fontSize: 12,
		backgroundColor: state.isFocused && PrimaryColor,
		color: state.isFocused && 'white'
		// ':hover': {
		//   ...provided[':active'],
		//   backgroundColor: !state.isSelected && 'rgba(0, 178, 255, 0.15 )'
		// }
	}),
	menu: provided => ({
		...provided,
		textAlign: 'left',
		zIndex: 9
	}),
	container: provided => ({
		...provided,
		fontSize: 12
	}),
	control: provided => ({
		...provided,
		cursor: 'pointer',
		borderColor: BorderColor,
		borderRadius: '5px',
		boxShadow: 'none',
		'&:hover': {
			borderColor: BorderColor
		},
		minHeight: '38px',
		backgroundColor: SurfaceColor
	}),
	singleValue: provided => ({
		...provided,
		color: 'inherit'
	}),
	indicatorSeparator: provided => ({
		...provided,
		backgroundColor: BorderColor,
		display: 'none'
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		padding: '5px',
		color: state.isFocused ? 'hsl(0,0%,80%)' : 'hsl(0,0%,80%)',
		'&:hover': {
			color: 'hsl(0,0%,80%)'
		}
	}),
	placeholder: defaultStyles => ({
		...defaultStyles,
		color: GreySidely
	}),

	valueContainer: (provided, _state) => ({
		...provided,
		height: '30px',
		fontWeight: '400'
	})
};
